import { registerBlockType } from '@wordpress/blocks'
import { __ } from '@wordpress/i18n'
import { useSelect, select, useDispatch, dispatch } from '@wordpress/data';
import { useEntityRecord } from '@wordpress/core-data';
import { createElement, useCallback, memo, useMemo, useState, useEffect } from '@wordpress/element'
import { PanelBody, RangeControl, Button, Panel, PanelRow, Dropdown, DropdownMenu, SelectControl, ColorPicker, ColorPalette, ToolsPanelItem, ComboboxControl, ToggleControl, MenuGroup, MenuItem, TextareaControl, Popover, Spinner } from '@wordpress/components'
import { __experimentalBoxControl as BoxControl } from '@wordpress/components';
import { useEntityProp } from '@wordpress/core-data';
import apiFetch from '@wordpress/api-fetch';
import { InnerBlocks, useBlockProps, useInnerBlocksProps } from "@wordpress/block-editor"
import { Icon, styles, settings, link, linkOff } from "@wordpress/icons";
import { applyFilters } from '@wordpress/hooks';

import { createBlock } from '@wordpress/blocks';

import { InspectorControls, BlockControls, AlignmentToolbar, RichText, __experimentalLinkControl as LinkControl } from '@wordpress/block-editor'
import { __experimentalInputControl as InputControl } from '@wordpress/components';
import breakPoints from '../../breakpoints'
const { RawHTML } = wp.element;
import { store } from '../../store'

import IconToggle from '../../components/icon-toggle'
import Typography from '../../components/typography'
import PGMailSubsctibe from '../../components/mail-subscribe'
import PGContactSupport from '../../components/contact-support'
import BreakpointToggle from '../../components/breakpoint-toggle'
import colorsPresets from '../../colors-presets'
import PGIconPicker from '../../components/icon-picker'



import PGtabs from '../../components/tabs'
import PGtab from '../../components/tab'
import PGStyles from '../../components/styles'
import PGCssLibrary from '../../components/css-library'



var myStore = wp.data.select('postgrid-shop');



registerBlockType("post-grid/tabs-nested", {
  apiVersion: 2,
  title: "Tabs",

  icon: {
    // Specifying a background color to appear with the icon e.g.: in the inserter.
    background: '#83bdf559',
    // Specifying a color for the icon (optional: if not set, a readable color will be automatically defined)
    foreground: '#fff',
    // Specifying an icon for the block
    src:
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><rect fill="#1d4ed8" y="10.75" width="10.72" height="3.64" /><path fill="#8db1ff" d="M1.94,12.09a.12.12,0,0,1,.08,0l.64.75a.11.11,0,1,1-.17.13l-.55-.65L1.38,13a.11.11,0,0,1-.15,0,.1.1,0,0,1,0-.15l.64-.75A.12.12,0,0,1,1.94,12.09Z" /><rect fill="#8db1ff" x="3.46" y="12.09" width="5.71" height="0.96" /><rect fill="#8db1ff" x="12.64" y="10.75" width="10.72" height="3.64" /><path fill="#1d4ed8" d="M14.58,13.05a.09.09,0,0,1-.08,0l-.64-.74a.11.11,0,1,1,.16-.14l.56.65.56-.65a.11.11,0,1,1,.16.14l-.64.74A.09.09,0,0,1,14.58,13.05Z" /><rect fill="#1d4ed8" x="16.11" y="12.09" width="5.71" height="0.96" /><rect fill="#8db1ff" x="25.28" y="10.75" width="10.72" height="3.64" /><path fill="#1d4ed8" d="M27.22,13.05a.09.09,0,0,1-.08,0l-.64-.74a.11.11,0,0,1,.16-.14l.56.65.56-.65a.11.11,0,1,1,.16.14L27.3,13A.09.09,0,0,1,27.22,13.05Z" /><rect fill="#1d4ed8" x="28.75" y="12.09" width="5.71" height="0.96" /><rect fill="#1d4ed8" y="16.58" width="36" height="8.66" /></svg>



    ,
  },


  attributes: {
    items: {
      type: 'array',
      default: [{ isActive: false, headerText: 'What is Lorem Ipsum?', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.', icon: '', iconToggle: '', styles: {}, }],
    },
    tabsWrap: {
      type: 'object',
      default: {
        options: {
          viewType: 'horizontal', //horizontal, vertical
          navsPosition: 'left', // left, right
        },

        styles:
        {
          backgroundColor: { Desktop: '' },

        },
      },
    },
    navsWrap: {
      type: 'object',
      default: {
        options: {
          class: '',
        },

        styles:
        {
          display: { Desktop: '' },

        },
      },
    },

    navItem: {
      type: 'object',
      default: {
        options: {
          viewType: 'horizontal', //horizontal, vertical
          position: 'left', // left, right, center
          class: '',
          activeTab: '',
        },

        styles:
        {
          backgroundColor: { Desktop: '' },
          color: { Desktop: '' },

          display: { Desktop: '' },

        },
      },
    },

    activeNavItem: {
      type: 'object',
      default: {
        options: {
          viewType: 'horizontal', //horizontal, vertical
          position: 'left', // left, right, center
          class: '',
          activeTab: '',
        },

        styles:
        {
          backgroundColor: { Desktop: '' },
          color: { Desktop: '' },
          display: { Desktop: '' },

        },
      },
    },

    navLabel: {
      type: 'object',
      default: {
        options: {
          viewType: 'horizontal', //horizontal, vertical
          position: 'left', // left, right, center
          class: '',
          activeTab: '',
        },

        styles:
        {
          backgroundColor: { Desktop: '' },
          color: { Desktop: '' },

        },
      },
    },

    icon: {
      type: 'object',
      default: {
        options: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: 'fas fa-angle-down', position: 'before', /* before, after */ class: 'icon', },

        styles:
        {
          backgroundColor: { Desktop: '' },
          color: { Desktop: '' },
          padding: { Desktop: '' },
          margin: { Desktop: '' },
          fontSize: { Desktop: '' },
        },
      },
    },
    panelWrap: {
      type: 'object',
      default: {
        options: {
          viewType: 'horizontal', //horizontal, vertical
          position: 'left', // left, right, center
          class: '',
          activeTab: '',
        },

        styles:
        {
          backgroundColor: { Desktop: '' },
          color: { Desktop: '' },

        },
      },
    },



    tabs: {
      "type": "array",
      "default": []
    },
    activeTab: {
      "type": "string"
    },
    viewType: {
      "type": "string",
      "default": 'horizontal', //horizontal, vertical
    },
    wrapper: {
      type: 'object',
      default: {
        options: {
          content: '',
          tag: 'div',
          class: '',
        },

        styles:
        {
          color: { Desktop: '' },
          display: {},
          position: {},
          overflow: {},
        },
      },
    },
    blockId: {
      "type": "string",
      "default": ''
    },
    customCss: {
      "type": "string",
      "default": ''
    },
    blockCssY: {
      "type": "object",
      "default": { items: {} }
    },
  },
  usesContext: ["postId", "loopIndex", "postType", "queryId"],

  supports: {
    "align": ["wide", "full"],
  },
  category: "post-grid",


  edit: function (props) {


    var attributes = props.attributes;
    var setAttributes = props.setAttributes;
    var context = props.context;
    var clientId = props.clientId;


    var blockId = attributes.blockId;

    var blockIdX = attributes.blockId ? attributes.blockId : 'pg' + clientId.split('-').pop();
    var blockClass = '.' + blockIdX;

    var wrapper = attributes.wrapper;
    var tabs = attributes.tabs;
    var activeTab = attributes.activeTab;
    var icon = attributes.icon;

    var navsWrap = attributes.navsWrap;
    var navItem = attributes.navItem;
    var activeNavItem = attributes.activeNavItem;

    var navLabel = attributes.navLabel;
    var panelWrap = attributes.panelWrap;


    var customCss = attributes.customCss;
    var blockCssY = attributes.blockCssY;


    var postId = context['postId'];
    var postType = context['postType'];
    let isProFeature = applyFilters('isProFeature', true);

    const [breakPointX, setBreakPointX] = useState(myStore.getBreakPoint());
    const [isLoading, setisLoading] = useState(false);
    const [postGridData, setPostGridData] = useState(window.PostGridPluginData);
    const [iconPickerIndex, setIconPickerIndex] = useState(99);
    const [iconPickerEnable, setIconPickerEnable] = useState(false);


    // Wrapper CSS Class Selectors
    var wrapperSelector = blockClass;
    var navsWrapSelector = blockClass + ' .navs-wrapper';
    var navItemSelector = blockClass + ' .nav-item';
    var activeNavItemSelector = blockClass + ' .nav-item-active';

    var navLabelSelector = blockClass + ' .nav-label';
    var panelWrapSelector = blockClass + ' .panels-wrap';

    var navIconSelector = blockClass + ' .nav-icon';



    useEffect(() => {

      setAttributes({ blockId: blockIdX });
      myStore.generateBlockCss(blockCssY.items, blockId, customCss);
    }, [clientId]);


    useEffect(() => {


      setAttributes({ customCss: customCss });

      myStore.generateBlockCss(blockCssY.items, blockId, customCss);
    }, [customCss]);


    useEffect(() => {

      myStore.generateBlockCss(blockCssY.items, blockId, customCss);

      //console.log(blockCssY.items);


    }, [blockCssY]);



    function bulkCssGenerate(cssObj) {

      var stylesObj = {};

      Object.entries(cssObj).map(args => {

        var selector = args[0];

        Object.entries(args[1]).map(x => {
          var attr = x[0];
          var cssPropty = myStore.cssAttrParse(attr);

          if (stylesObj[selector] == undefined) {
            stylesObj[selector] = {};
          }

          if (stylesObj[selector][cssPropty] == undefined) {
            stylesObj[selector][cssPropty] = {};
          }

          stylesObj[selector][cssPropty] = x[1]
        })


      })

      var cssItems = { ...blockCssY.items };
      var cssItemsX = { ...cssItems, ...stylesObj }
      console.log(cssItemsX);

      setAttributes({ blockCssY: { items: cssItemsX } });



    }




    var breakPointList = [{ label: 'Select..', icon: '', value: '' }];

    for (var x in breakPoints) {

      var item = breakPoints[x];
      breakPointList.push({ label: item.name, icon: item.icon, value: item.id })

    }



    function handleLinkClick(ev) {

      ev.stopPropagation();
      ev.preventDefault();
      return false;
    }




    function onChangeStyleWrapper(sudoScource, newVal, attr) {
      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, wrapper);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ wrapper: object });




      var elementSelector = myStore.getElementSelector(sudoScource, wrapperSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStyleWrapper(sudoScource, key) {

      var object = myStore.deletePropertyDeep(wrapper, [sudoScource, key, breakPointX]);
      setAttributes({ wrapper: object });


      var elementSelector = myStore.getElementSelector(sudoScource, wrapperSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });


    }


    function onAddStyleWrapper(sudoScource, key) {


      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, wrapper);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ wrapper: object });

    }


    function onChangeStyleNavLabel(sudoScource, newVal, attr) {
      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, navLabel);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ navLabel: object });




      var elementSelector = myStore.getElementSelector(sudoScource, navLabelSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStyleNavLabel(sudoScource, key) {

      var object = myStore.deletePropertyDeep(navLabel, [sudoScource, key, breakPointX]);
      setAttributes({ navLabel: object });


      var elementSelector = myStore.getElementSelector(sudoScource, navLabelSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });


    }


    function onAddStyleNavLabel(sudoScource, key) {


      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, navLabel);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ navLabel: object });

    }


    function onPickCssLibraryNavLabel(args) {


      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        navLabel[sudoScource] = sudoScourceArgs;
      })

      var navLabelX = Object.assign({}, navLabel);
      setAttributes({ navLabel: navLabelX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, navLabelSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }



    function onChangeStylepanelWrap(sudoScource, newVal, attr) {
      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, panelWrap);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ panelWrap: object });




      var elementSelector = myStore.getElementSelector(sudoScource, panelWrapSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStylepanelWrap(sudoScource, key) {

      var object = myStore.deletePropertyDeep(panelWrap, [sudoScource, key, breakPointX]);
      setAttributes({ panelWrap: object });


      var elementSelector = myStore.getElementSelector(sudoScource, panelWrapSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });


    }


    function onAddStylepanelWrap(sudoScource, key) {


      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, panelWrap);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ panelWrap: object });

    }


    function onPickCssLibrarypanelWrap(args) {


      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        panelWrap[sudoScource] = sudoScourceArgs;
      })

      var panelWrapX = Object.assign({}, panelWrap);
      setAttributes({ panelWrap: panelWrapX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, panelWrapSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }










    function onChangeStyleIcon(sudoScource, newVal, attr) {



      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, icon);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ icon: object });

      var elementSelector = myStore.getElementSelector(sudoScource, navIconSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });






    }






    function onRemoveStyleIcon(sudoScource, key) {


      var object = myStore.deletePropertyDeep(icon, [sudoScource, key, breakPointX]);
      setAttributes({ icon: object });


      var elementSelector = myStore.getElementSelector(sudoScource, navIconSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });


    }


    function onAddStyleIcon(sudoScource, key) {


      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, icon);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ icon: object });
    }






    function onPickCssLibraryIcon(args) {


      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        icon[sudoScource] = sudoScourceArgs;
      })

      var iconX = Object.assign({}, icon);
      setAttributes({ icon: iconX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, navIconSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }





    function onChangeStyleNavsWrap(sudoScource, newVal, attr) {

      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, navsWrap);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ navsWrap: object });

      var elementSelector = myStore.getElementSelector(sudoScource, navsWrapSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStyleNavsWrap(sudoScource, key) {

      var object = myStore.deletePropertyDeep(navsWrap, [sudoScource, key, breakPointX]);
      setAttributes({ navsWrap: object });

      var elementSelector = myStore.getElementSelector(sudoScource, navsWrapSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });

    }


    function onAddStyleNavsWrap(sudoScource, key) {

      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, navsWrap);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ navsWrap: object });
    }


    function onPickCssLibraryNavsWrap(args) {

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        navsWrap[sudoScource] = sudoScourceArgs;
      })

      var navsWrapX = Object.assign({}, navsWrap);
      setAttributes({ navsWrap: navsWrapX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, navsWrapSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }






    function onChangeStyleNavItem(sudoScource, newVal, attr) {

      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, navItem);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ navItem: object });

      var elementSelector = myStore.getElementSelector(sudoScource, navItemSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStyleNavItem(sudoScource, key) {

      var object = myStore.deletePropertyDeep(navItem, [sudoScource, key, breakPointX]);
      setAttributes({ navItem: object });

      var elementSelector = myStore.getElementSelector(sudoScource, navItemSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });

    }


    function onAddStyleNavItem(sudoScource, key) {

      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, navItem);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ navItem: object });
    }


    function onPickCssLibraryNavItem(args) {

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        navItem[sudoScource] = sudoScourceArgs;
      })

      var navItemX = Object.assign({}, navItem);
      setAttributes({ navItem: navItemX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, navItemSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }




    function onChangeStyleActiveNavItem(sudoScource, newVal, attr) {

      var path = [sudoScource, attr, breakPointX]
      let obj = Object.assign({}, activeNavItem);
      const object = myStore.updatePropertyDeep(obj, path, newVal)

      setAttributes({ activeNavItem: object });

      var elementSelector = myStore.getElementSelector(sudoScource, activeNavItemSelector);
      var cssPropty = myStore.cssAttrParse(attr);

      if (blockCssY.items[elementSelector] == undefined) {
        blockCssY.items[elementSelector] = {};
      }

      var cssPath = [elementSelector, cssPropty, breakPointX]
      const cssItems = myStore.updatePropertyDeep(blockCssY.items, cssPath, newVal)

      setAttributes({ blockCssY: { items: cssItems } });

    }


    function onRemoveStyleActiveNavItem(sudoScource, key) {

      var object = myStore.deletePropertyDeep(activeNavItem, [sudoScource, key, breakPointX]);
      setAttributes({ activeNavItem: object });

      var elementSelector = myStore.getElementSelector(sudoScource, activeNavItemSelector);
      var cssPropty = myStore.cssAttrParse(key);
      var cssObject = myStore.deletePropertyDeep(blockCssY.items, [elementSelector, cssPropty, breakPointX]);
      setAttributes({ blockCssY: { items: cssObject } });

    }


    function onAddStyleActiveNavItem(sudoScource, key) {

      var path = [sudoScource, key, breakPointX]
      let obj = Object.assign({}, activeNavItem);
      const object = myStore.addPropertyDeep(obj, path, '')
      setAttributes({ activeNavItem: object });
    }


    function onPickCssLibraryActiveNavItem(args) {

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        activeNavItem[sudoScource] = sudoScourceArgs;
      })

      var activeNavItemX = Object.assign({}, activeNavItem);
      setAttributes({ activeNavItem: activeNavItemX });

      var styleObj = {};

      Object.entries(args).map(x => {
        var sudoScource = x[0];
        var sudoScourceArgs = x[1];
        var elementSelector = myStore.getElementSelector(sudoScource, activeNavItemSelector);


        var sudoObj = {};
        Object.entries(sudoScourceArgs).map(y => {

          var cssPropty = y[0];
          var cssProptyVal = y[1];
          var cssProptyKey = myStore.cssAttrParse(cssPropty);
          sudoObj[cssProptyKey] = cssProptyVal;
        })

        styleObj[elementSelector] = sudoObj;
      })


      var cssItems = Object.assign(blockCssY.items, styleObj);
      setAttributes({ blockCssY: { items: cssItems } });
    }






    const blockProps = useBlockProps({
      className: `${useBlockProps().className} ${blockId} `,
    });

    const setActiveTab = (uid) => {
      setAttributes({ activeTab: uid });
      const parentBlock = select('core/block-editor').getBlock(clientId);

      parentBlock.innerBlocks.forEach((innerBlock) => {
        dispatch('core/block-editor').updateBlockAttributes(
          innerBlock.clientId,
          {
            activeTab: uid,
          }
        );
      });
    };

    const addNewTab = () => {
      const tab = createBlock('post-grid/tabs-nested-item');
      const position = tabs.length;
      dispatch('core/block-editor').insertBlock(tab, position, clientId);
      setAttributes({
        tabs: [
          ...tabs,
          {
            uid: tab.clientId,
            title: `Tab ${tabs.length + 1}`,
            icon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },

          },
        ],
      });
      //setActiveTab(tab.clientId);
    };

    const tabTitleChange = (newValue) => {
      setAttributes({
        tabs: [
          ...tabs.map((t) => {
            return t.uid === activeTab
              ? {
                ...t,
                title: newValue,
              }
              : t;
          }),
        ],
      });
    };

    useEffect(() => {
      if (tabs.length && !activeTab) {
        //setActiveTab(tabs[0].uid);
      }
    }, [tabs]);


    const MY_TEMPLATE = [

    ];


    return (



      <>

        <InspectorControls >
          <div className='px-3' initialOpen={false}>


            <PanelBody title="Pre-Sets" initialOpen={true}>

              <div className='grid grid-cols-2 gap-2'>

                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {

                    var cssObj = {};

                    var styles0 = { display: { "Desktop": "block" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;


                    var navsWrapStyles = { display: { "Desktop": "flex" }, justifyContent: { "Desktop": "start" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: navsWrapStyles } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);

                    cssObj[elementSelector1] = navsWrapStyles;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 5px 0px 0px" }, justifyContent: {}, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}
                  title={"Click to Apply"}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 169.7"><defs></defs><rect fill="#ffffff" width="109.1" height="37.04" /><path fill="#3c3c3b" d="M19.71,13.65a1.07,1.07,0,0,1,.82.38L27,21.61a1.08,1.08,0,0,1-.11,1.52A1.09,1.09,0,0,1,25.39,23l-5.68-6.63L14,23a1.09,1.09,0,0,1-1.53.11,1.07,1.07,0,0,1-.12-1.52L18.89,14A1.08,1.08,0,0,1,19.71,13.65Z" /><rect fill="#3c3c3b" x="35.26" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="128.7" width="109.1" height="37.04" /><path fill="#ffffff" d="M148.41,23.4a1.1,1.1,0,0,1-.82-.38l-6.5-7.58A1.09,1.09,0,0,1,142.74,14l5.67,6.62L154.09,14a1.08,1.08,0,1,1,1.64,1.41L149.23,23A1.07,1.07,0,0,1,148.41,23.4Z" /><rect fill="#ffffff" x="163.96" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="257.4" width="109.1" height="37.04" /><path fill="#ffffff" d="M277.11,23.4a1.1,1.1,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L282.79,14a1.08,1.08,0,1,1,1.64,1.41L277.93,23A1.07,1.07,0,0,1,277.11,23.4Z" /><rect fill="#ffffff" x="292.66" y="13.65" width="58.16" height="9.75" /><rect fill="#ffffff" y="37.04" width="500" height="132.66" /></svg>
                </div>

                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {

                    var cssObj = {};

                    var styles0 = { display: { "Desktop": "block" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;


                    var navsWrapStyles = { display: { "Desktop": "flex" }, justifyContent: { "Desktop": "center" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: navsWrapStyles } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);

                    cssObj[elementSelector1] = navsWrapStyles;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 5px 0px 0px" }, justifyContent: {}, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}

                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 169.7"><defs></defs><rect fill="#ffffff" x="66.75" width="109.1" height="37.04" /><path fill="#3c3c3b" d="M86.46,13.65a1.07,1.07,0,0,1,.82.38l6.5,7.58a1.08,1.08,0,0,1-.11,1.52A1.09,1.09,0,0,1,92.14,23l-5.68-6.63L80.78,23a1.08,1.08,0,0,1-1.64-1.41L85.64,14A1.07,1.07,0,0,1,86.46,13.65Z" /><rect fill="#3c3c3b" x="102.01" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="195.45" width="109.1" height="37.04" /><path fill="#ffffff" d="M215.16,23.4a1.08,1.08,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L220.84,14a1.08,1.08,0,1,1,1.64,1.41L216,23A1.07,1.07,0,0,1,215.16,23.4Z" /><rect fill="#ffffff" x="230.71" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="324.15" width="109.1" height="37.04" /><path fill="#ffffff" d="M343.86,23.4A1.08,1.08,0,0,1,343,23l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L349.54,14a1.08,1.08,0,1,1,1.64,1.41L344.68,23A1.07,1.07,0,0,1,343.86,23.4Z" /><rect fill="#ffffff" x="359.41" y="13.65" width="58.16" height="9.75" /><rect fill="#ffffff" y="37.04" width="500" height="132.66" /></svg>
                </div>
                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {

                    var cssObj = {};

                    var styles0 = { display: { "Desktop": "block" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;


                    var styles1 = { display: { "Desktop": "flex" }, justifyContent: { "Desktop": "end" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: styles1 } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);

                    cssObj[elementSelector1] = styles1;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 5px 0px 0px" }, justifyContent: {}, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 169.7"><rect fill="#ffffff" x="133.5" width="109.1" height="37.04" /><path fill="#3c3c3b" d="M153.21,13.65A1.07,1.07,0,0,1,154,14l6.5,7.58A1.08,1.08,0,0,1,158.89,23l-5.68-6.63L147.53,23a1.08,1.08,0,0,1-1.64-1.41l6.5-7.58A1.07,1.07,0,0,1,153.21,13.65Z" /><rect fill="#3c3c3b" x="168.76" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="262.2" width="109.1" height="37.04" /><path fill="#ffffff" d="M281.91,23.4a1.07,1.07,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L287.59,14a1.07,1.07,0,0,1,1.52-.12,1.08,1.08,0,0,1,.12,1.53L282.73,23A1.07,1.07,0,0,1,281.91,23.4Z" /><rect fill="#ffffff" x="297.46" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="390.9" width="109.1" height="37.04" /><path fill="#ffffff" d="M410.61,23.4a1.07,1.07,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L416.29,14a1.07,1.07,0,0,1,1.52-.12,1.08,1.08,0,0,1,.12,1.53L411.43,23A1.07,1.07,0,0,1,410.61,23.4Z" /><rect fill="#ffffff" x="426.16" y="13.65" width="58.16" height="9.75" /><rect fill="#ffffff" y="37.04" width="500" height="132.66" /></svg>
                </div>

                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {

                    var cssObj = {};


                    var styles0 = { display: { "Desktop": "block" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;



                    var navsWrapStyles = { display: { "Desktop": "flex" }, justifyContent: { "Desktop": "space-between" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: navsWrapStyles } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);

                    cssObj[elementSelector1] = navsWrapStyles;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 5px 0px 0px" }, justifyContent: {}, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 169.7"><defs></defs><rect fill="#ffffff" y="37.04" width="500" height="132.66" /><rect fill="#ffffff" width="109.1" height="37.04" /><path fill="#3c3c3b" d="M19.71,13.65a1.07,1.07,0,0,1,.82.38L27,21.61a1.08,1.08,0,0,1-.11,1.52A1.09,1.09,0,0,1,25.39,23l-5.68-6.63L14,23a1.09,1.09,0,0,1-1.53.11,1.07,1.07,0,0,1-.12-1.52L18.89,14A1.08,1.08,0,0,1,19.71,13.65Z" /><rect fill="#3c3c3b" x="35.26" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="195.45" width="109.1" height="37.04" /><path fill="#ffffff" d="M215.16,23.4a1.08,1.08,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L220.84,14a1.08,1.08,0,1,1,1.64,1.41L216,23A1.07,1.07,0,0,1,215.16,23.4Z" /><rect fill="#ffffff" x="230.71" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="390.9" width="109.1" height="37.04" /><path fill="#ffffff" d="M410.61,23.4a1.07,1.07,0,0,1-.82-.38l-6.5-7.58a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L416.29,14a1.07,1.07,0,0,1,1.52-.12,1.08,1.08,0,0,1,.12,1.53L411.43,23A1.07,1.07,0,0,1,410.61,23.4Z" /><rect fill="#ffffff" x="426.16" y="13.65" width="58.16" height="9.75" /></svg>
                </div>
                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {

                    var cssObj = {};


                    var styles0 = { display: { "Desktop": "block" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;



                    var navsWrapStyles = { display: { "Desktop": "flex" }, justifyContent: { "Desktop": "space-around" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: navsWrapStyles } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);

                    cssObj[elementSelector1] = navsWrapStyles;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 5px 0px 0px" }, justifyContent: {}, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 169.7"><rect fill="#ffffff" y="37.04" width="500" height="132.66" /><rect fill="#ffffff" x="24.4" width="109.1" height="37.04" /><path fill="#3c3c3b" d="M44.11,13.65a1.07,1.07,0,0,1,.82.38l6.5,7.58A1.08,1.08,0,0,1,49.79,23l-5.68-6.63L38.43,23a1.08,1.08,0,0,1-1.64-1.41L43.29,14A1.07,1.07,0,0,1,44.11,13.65Z" /><rect fill="#3c3c3b" x="59.66" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="198" width="109.1" height="37.04" /><path fill="#ffffff" d="M217.71,23.4a1.1,1.1,0,0,1-.82-.38l-6.5-7.58A1.09,1.09,0,0,1,212,14l5.67,6.62L223.39,14A1.09,1.09,0,1,1,225,15.44L218.54,23A1.1,1.1,0,0,1,217.71,23.4Z" /><rect fill="#ffffff" x="233.26" y="13.65" width="58.16" height="9.75" /><rect fill="#3c3c3b" x="371.61" width="109.1" height="37.04" /><path fill="#ffffff" d="M391.32,23.4a1.07,1.07,0,0,1-.82-.38L384,15.44a1.08,1.08,0,0,1,.12-1.53,1.07,1.07,0,0,1,1.52.12l5.68,6.62L397,14a1.07,1.07,0,0,1,1.52-.12,1.08,1.08,0,0,1,.12,1.53L392.14,23A1.07,1.07,0,0,1,391.32,23.4Z" /><rect fill="#ffffff" x="406.87" y="13.65" width="58.16" height="9.75" /></svg>
                </div>
                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer relative'
                  onClick={ev => {



                    if (isProFeature) {

                      alert("Sorry this is only abilable in pro version")
                      return;
                    }

                    var cssObj = {};

                    var styles0 = { display: { "Desktop": "flex" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;


                    var styles1 = { "display": { "Desktop": "block" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: styles1 } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);
                    cssObj[elementSelector1] = styles1;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 0px 0px 0px" }, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" }, width: { "Desktop": "250px" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;

                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}
                >
                  {isProFeature && (
                    <span className='bg-amber-400 mx-2 rounded-sm px-4  text-white hover:text-white absolute top-1/2 left-1/2 -translate-x-1/2	-translate-y-1/2	'>
                      <a target="_blank" href={'https://pickplugins.com/post-grid/?utm_source=search&utm_term=blockaccordion&utm_campaign=pluginPostGrid&utm_medium=search'}>Pro</a>
                    </span>
                  )}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 132.66"><defs></defs><rect fill="#ffffff" width="152.68" height="34.15" /><path fill="#3c3c3b" d="M18.17,12.58a1,1,0,0,1,.76.35l6,7a1,1,0,1,1-1.51,1.3l-5.24-6.1-5.23,6.1a1,1,0,1,1-1.52-1.3l6-7A1,1,0,0,1,18.17,12.58Z" /><rect fill="#3c3c3b" x="32.51" y="12.58" width="53.63" height="8.99" /><rect fill="#3c3c3b" y="49.17" width="152.68" height="34.15" /><path fill="#ffffff" d="M18.17,70.75a1,1,0,0,1-.75-.35l-6-7a1,1,0,1,1,1.52-1.3l5.23,6.1,5.24-6.1a1,1,0,1,1,1.51,1.3l-6,7A1,1,0,0,1,18.17,70.75Z" /><rect fill="#ffffff" x="32.51" y="61.76" width="53.63" height="8.99" /><rect fill="#3c3c3b" y="98.35" width="152.68" height="34.15" /><path fill="#ffffff" d="M18.17,119.92a1,1,0,0,1-.75-.35l-6-7a1,1,0,1,1,1.52-1.3l5.23,6.11,5.24-6.11a1,1,0,1,1,1.51,1.3l-6,7A1,1,0,0,1,18.17,119.92Z" /><rect fill="#ffffff" x="32.51" y="110.93" width="53.63" height="8.99" /><rect fill="#ffffff" x="131.21" width="368.79" height="132.66" /></svg>
                </div>




                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer relative'
                  onClick={ev => {


                    if (isProFeature) {

                      alert("Sorry this is only abilable in pro version")
                      return;
                    }




                    var cssObj = {};

                    var styles0 = { display: { "Desktop": "flex" }, };
                    setAttributes({ wrapper: { ...wrapper, styles: styles0 } });

                    var elementSelector0 = myStore.getElementSelector('styles', wrapperSelector);
                    cssObj[elementSelector0] = styles0;


                    var styles1 = { "display": { "Desktop": "block" }, order: { "Desktop": "2" } };
                    setAttributes({ navsWrap: { ...navsWrap, styles: styles1 } });

                    var elementSelector1 = myStore.getElementSelector('styles', navsWrapSelector);
                    cssObj[elementSelector1] = styles1;



                    var styles2 = { display: { "Desktop": "flex" }, "color": { "Desktop": "#ffffff" }, padding: { "Desktop": "5px 15px 5px 15px" }, backgroundColor: { "Desktop": "#3236ff" }, margin: { "Desktop": "0px 0px 0px 0px" }, alignItems: { "Desktop": "center" }, cursor: { "Desktop": "pointer" }, width: { "Desktop": "250px" }, justifyContent: { "Desktop": "space-between" } };
                    setAttributes({ navItem: { ...navItem, styles: styles2 } });


                    var elementSelector2 = myStore.getElementSelector('styles', navItemSelector);
                    cssObj[elementSelector2] = styles2;




                    var styles3 = { display: { "Desktop": "flex" }, color: { "Desktop": "" }, backgroundColor: { "Desktop": "#afb1ff" } };
                    setAttributes({ activeNavItem: { ...activeNavItem, styles: styles3 } });

                    var elementSelector3 = myStore.getElementSelector('styles', activeNavItemSelector);
                    //bulkCssGenerate(styles, elementSelector3)
                    cssObj[elementSelector3] = styles3;



                    var styles4 = { padding: { "Desktop": "0px 10px 0px 10px" } };
                    setAttributes({ navLabel: { ...navLabel, styles: styles4 } });

                    var elementSelector4 = myStore.getElementSelector('styles', navLabelSelector);
                    cssObj[elementSelector4] = styles4;


                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'after' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });

                    var elementSelector5 = myStore.getElementSelector('styles', navIconSelector);
                    cssObj[elementSelector5] = styles5;


                    var styles6 = { backgroundColor: { "Desktop": "#afb1ff" }, padding: { "Desktop": "10px 10px 10px 10px" }, margin: { "Desktop": "0px 0px 0px 0px" } };
                    setAttributes({ panelWrap: { ...panelWrap, styles: styles6 } });

                    var elementSelector6 = myStore.getElementSelector('styles', panelWrapSelector);

                    cssObj[elementSelector6] = styles6;


                    bulkCssGenerate(cssObj)

                  }}

                >
                  {isProFeature && (
                    <span className='bg-amber-400 mx-2 rounded-sm px-3  text-white hover:text-white absolute top-1/2 left-1/2 -translate-x-1/2	-translate-y-1/2	'>
                      <a target="_blank" href={'https://pickplugins.com/post-grid/?utm_source=search&utm_term=blockaccordion&utm_campaign=pluginPostGrid&utm_medium=search'}>Pro</a>
                    </span>
                  )}

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 132.66"><defs></defs><rect fill="#ffffff" x="347.29" width="152.69" height="34.15" transform="translate(847.27 34.15) rotate(-180)" /><path fill="#3c3c3b" d="M481.8,12.58a1,1,0,0,0-.76.35l-6,7a1,1,0,1,0,1.52,1.3l5.23-6.1,5.24,6.1a1,1,0,0,0,1.4.11,1,1,0,0,0,.11-1.41l-6-7A1,1,0,0,0,481.8,12.58Z" /><rect fill="#3c3c3b" x="413.84" y="12.58" width="53.63" height="8.99" transform="translate(881.31 34.15) rotate(-180)" /><rect fill="#3c3c3b" x="347.29" y="49.18" width="152.69" height="34.15" transform="translate(847.27 132.51) rotate(-180)" /><path fill="#ffffff" d="M481.8,70.75a1,1,0,0,0,.76-.35l6-7a1,1,0,0,0-.11-1.41,1,1,0,0,0-1.4.11l-5.24,6.1-5.23-6.1a1,1,0,1,0-1.52,1.3l6,7A1,1,0,0,0,481.8,70.75Z" /><rect fill="#ffffff" x="413.84" y="61.76" width="53.63" height="8.99" transform="translate(881.31 132.51) rotate(-180)" /><rect fill="#3c3c3b" x="347.29" y="98.35" width="152.69" height="34.15" transform="translate(847.27 230.86) rotate(-180)" /><path fill="#ffffff" d="M481.8,119.92a1,1,0,0,0,.76-.34l6-7a1,1,0,0,0-.11-1.41,1,1,0,0,0-1.4.11l-5.24,6.1-5.23-6.1a1,1,0,1,0-1.52,1.3l6,7A1,1,0,0,0,481.8,119.92Z" /><rect fill="#ffffff" x="413.84" y="110.94" width="53.63" height="8.99" transform="translate(881.31 230.86) rotate(-180)" /><rect fill="#ffffff" x="0.02" width="368.8" height="132.66" /></svg>
                </div>

              </div>

              <label className='my-4 block' for="">Icon Positions</label>

              <div className='grid grid-cols-2 gap-2'>


                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {



                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'before' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });



                  }}
                >

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238 37"><rect fill="#ffffff" width="109.19" height="37" /><path fill="#3c3c3b" d="M21.68,13.63a1.1,1.1,0,0,0-.83.38l-6.5,7.57A1.08,1.08,0,1,0,16,23l5.69-6.61L27.36,23A1.08,1.08,0,1,0,29,21.58L22.5,14A1.1,1.1,0,0,0,21.68,13.63Z" /><rect fill="#3c3c3b" x="36.89" y="13.63" width="58.21" height="9.74" transform="translate(132 37) rotate(-180)" /><rect fill="#3c3c3b" x="128.81" width="109.19" height="37" /><path fill="#ffffff" d="M148.54,23.37a1.1,1.1,0,0,1-.83-.38l-6.5-7.57A1.08,1.08,0,1,1,142.85,14l5.69,6.61L154.22,14a1.08,1.08,0,1,1,1.64,1.41L149.36,23A1.1,1.1,0,0,1,148.54,23.37Z" /><rect fill="#ffffff" x="164.1" y="13.63" width="58.21" height="9.74" /></svg>
                </div>


                <div className='bg-[#5655ff] hover:bg-[#3737c7] p-2 cursor-pointer'
                  onClick={ev => {



                    var styles5 = { fontSize: { "Desktop": "20px" } };
                    var options5 = { ...icon.options, position: 'after' };
                    setAttributes({ icon: { ...icon, styles: styles5, options: options5 } });



                  }}

                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238 37"><rect fill="#ffffff" width="109.19" height="37" /><path fill="#3c3c3b" d="M87.52,13.63a1.1,1.1,0,0,1,.82.38l6.5,7.57A1.08,1.08,0,1,1,93.2,23l-5.68-6.61L81.84,23a1.09,1.09,0,0,1-1.65-1.41L86.69,14A1.1,1.1,0,0,1,87.52,13.63Z" /><rect fill="#3c3c3b" x="14.09" y="13.63" width="58.21" height="9.74" /><rect fill="#3c3c3b" x="128.81" width="109.19" height="37" /><path fill="#ffffff" d="M214.72,23.37a1.07,1.07,0,0,0,.82-.38l6.51-7.57A1.09,1.09,0,1,0,220.4,14l-5.68,6.61L209,14a1.09,1.09,0,0,0-1.65,1.41L213.9,23A1.07,1.07,0,0,0,214.72,23.37Z" /><rect fill="#ffffff" x="140.95" y="13.63" width="58.21" height="9.74" transform="translate(340.11 37) rotate(-180)" /></svg>
                </div>

              </div>


            </PanelBody>



            <PanelBody title="Wrapper" initialOpen={false}>

              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">



                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={wrapper} onChange={onChangeStyleWrapper} onAdd={onAddStyleWrapper} onRemove={onRemoveStyleWrapper} />
                </PGtab>
              </PGtabs>

            </PanelBody>



            <PanelBody title="Navs Wrapper" initialOpen={false}>

              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">



                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={navsWrap} onChange={onChangeStyleNavsWrap} onAdd={onAddStyleNavsWrap} onRemove={onRemoveStyleNavsWrap} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={navsWrap} onChange={onPickCssLibraryNavsWrap} />
                </PGtab>
              </PGtabs>

            </PanelBody>


            <PanelBody title="Nav Item" initialOpen={false}>
              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">
                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={navItem} onChange={onChangeStyleNavItem} onAdd={onAddStyleNavItem} onRemove={onRemoveStyleNavItem} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={navItem} onChange={onPickCssLibraryNavItem} />
                </PGtab>
              </PGtabs>

            </PanelBody>


            <PanelBody title="Active Nav Item" initialOpen={false}>
              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">
                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={activeNavItem} onChange={onChangeStyleActiveNavItem} onAdd={onAddStyleActiveNavItem} onRemove={onRemoveStyleActiveNavItem} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={activeNavItem} onChange={onPickCssLibraryActiveNavItem} />
                </PGtab>
              </PGtabs>

            </PanelBody>


            <PanelBody title="Nav Label" initialOpen={false}>
              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">
                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={navLabel} onChange={onChangeStyleNavLabel} onAdd={onAddStyleNavLabel} onRemove={onRemoveStyleNavLabel} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={navLabel} onChange={onPickCssLibraryNavLabel} />
                </PGtab>
              </PGtabs>

            </PanelBody>


            <PanelBody title="Content Wrap" initialOpen={false}>
              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                ]}
              >
                <PGtab name="options">
                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={panelWrap} onChange={onChangeStylepanelWrap} onAdd={onAddStylepanelWrap} onRemove={onRemoveStylepanelWrap} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={panelWrap} onChange={onPickCssLibrarypanelWrap} />
                </PGtab>
              </PGtabs>

            </PanelBody>



            <PanelBody title="Nav Icon" initialOpen={false}>


              <PGtabs
                activeTab="options"
                orientation="horizontal"
                activeClass="active-tab"
                onSelect={(tabName) => { }}
                tabs={[
                  {
                    name: 'options',
                    title: 'Options',
                    icon: settings,
                    className: 'tab-settings',
                  },
                  {
                    name: 'styles',
                    title: 'Styles',
                    icon: styles,
                    className: 'tab-style',
                  },
                  {
                    name: 'css',
                    title: 'CSS Library',
                    icon: styles,
                    className: 'tab-css',
                  },
                ]}
              >
                <PGtab name="options">

                  <PanelRow>
                    <label for="">Choose Icon</label>

                    <PGIconPicker library={icon.options.library} srcType={icon.options.srcType} iconSrc={icon.options.iconSrc} onChange={(arg) => {


                      var options = { ...icon.options, srcType: arg.srcType, library: arg.library, iconSrc: arg.iconSrc };
                      setAttributes({ icon: { ...icon, options: options } });

                    }} />
                  </PanelRow>



                  <PanelRow>
                    <label for="">Icon postion</label>

                    <SelectControl
                      label=""
                      value={icon.options.position}
                      options={[

                        { label: 'Choose Position', value: '' },
                        { label: 'Before', value: 'before' },
                        { label: 'After', value: 'after' },

                      ]}
                      onChange={(newVal) => {


                        var options = { ...icon.options, position: newVal };
                        setAttributes({ icon: { ...icon, options: options } });


                      }



                      }
                    />
                  </PanelRow>

                </PGtab>
                <PGtab name="styles">
                  <PGStyles obj={icon} onChange={onChangeStyleIcon} onAdd={onAddStyleIcon} onRemove={onRemoveStyleIcon} />
                </PGtab>
                <PGtab name="css">
                  <PGCssLibrary blockId={blockId} obj={icon} onChange={onPickCssLibraryIcon} />
                </PGtab>
              </PGtabs>







            </PanelBody>



            <PanelBody title="Custom Style" initialOpen={false}>


              <p>Please use following class selector to apply your custom CSS</p>


              <div className='my-3'>
                <p className='font-bold'>Text </p>
                <p><code>{wrapperSelector}{'{}'} </code></p>
              </div>



              <TextareaControl
                label="Custom CSS"
                help="Do not use 'style' tag"
                value={customCss}
                onChange={(value) => {
                  setAttributes({ customCss: value })

                }}
              />
            </PanelBody>

            <div className='px-2'>
              <PGMailSubsctibe />
              <PGContactSupport utm={{ utm_source: 'BlockText', utm_campaign: 'PostGridCombo', utm_content: 'BlockOptions' }} />
            </div>


          </div>






        </InspectorControls >







        <div {...blockProps}>
          <Button
            className='my-4'
            variant={'primary'}
            icon={'plus'}
            onClick={addNewTab}
          >
            {__('Add Tab', 'gtt')}
          </Button>

          <div className={' navs-wrapper  '}>
            {tabs.map((tab, index) => {
              return (
                <div
                  key={tab.uid}
                  className={` ${tab.uid === activeTab
                    ? ' nav-item nav-item-active'
                    : ' nav-item '
                    }`}
                  role="tab"
                  tabIndex={index}
                  onClick={() => setActiveTab(tab.uid)}
                >

                  {icon.options.position == 'before' && (

                    <>

                      {tab.icon.iconSrc == undefined || tab.icon.iconSrc.length == 0 && (


                        <div className='nav-icon' onClick={ev => {
                          setIconPickerIndex(index)
                          setIconPickerEnable(!iconPickerEnable)
                        }}>
                          <span className={icon.options.iconSrc} ></span>
                        </div>
                      )}


                      {/* {!iconPickerEnable && (
                          <div className='nav-icon' onClick={ev => {
                            setIconPickerIndex(index)
                            setIconPickerEnable(!iconPickerEnable)
                          }}>B
                            <span className={tab.icon.iconSrc} ></span>
                          </div>
                        )} */}


                      {iconPickerEnable && iconPickerIndex != index && (
                        <div className='nav-icon' onClick={ev => {
                          setIconPickerIndex(index)
                          setIconPickerEnable(!iconPickerEnable)
                        }}>
                          <span className={tab.icon.iconSrc} ></span>
                        </div>
                      )}



                      {iconPickerIndex == index && iconPickerEnable && (
                        <PGIconPicker library={tab.icon.library} srcType={tab.icon.srcType} iconSrc={tab.icon.iconSrc} onChange={arg => {

                          tabs[index].icon = { srcType: arg.srcType, library: arg.library, iconSrc: arg.iconSrc }
                          setAttributes({ tabs: tabs });
                          setIconPickerEnable(!iconPickerEnable)
                          setIconPickerIndex(99)


                        }} />
                      )}






                    </>



                  )}

                  <RichText
                    className=' nav-label'
                    tagName="div"
                    value={tab.title}
                    onChange={tabTitleChange}
                  />

                  {icon.options.position == 'after' && (
                    <>

                      {tab.icon.iconSrc == undefined || tab.icon.iconSrc.length == 0 && (


                        <div className='nav-icon' onClick={ev => {
                          setIconPickerIndex(index)
                          setIconPickerEnable(!iconPickerEnable)
                        }}>
                          <span className={icon.options.iconSrc} ></span>
                        </div>
                      )}

                      {/* {!iconPickerEnable && (
                          <div className='nav-icon' onClick={ev => {
                            setIconPickerIndex(index)
                            setIconPickerEnable(!iconPickerEnable)
                          }}>
                            <span className={tab.icon.iconSrc} ></span>
                          </div>
                        )} */}


                      {iconPickerEnable && iconPickerIndex != index && (
                        <div className='nav-icon' onClick={ev => {
                          setIconPickerIndex(index)
                          setIconPickerEnable(!iconPickerEnable)
                        }}>
                          <span className={tab.icon.iconSrc} ></span>
                        </div>
                      )}



                      {iconPickerIndex == index && iconPickerEnable && (
                        <PGIconPicker library={tab.icon.library} srcType={tab.icon.srcType} iconSrc={tab.icon.iconSrc} onChange={arg => {

                          tabs[index].icon = { srcType: arg.srcType, library: arg.library, iconSrc: arg.iconSrc }
                          setAttributes({ tabs: tabs });
                          setIconPickerEnable(!iconPickerEnable)
                          setIconPickerIndex(99)


                        }} />
                      )}

                    </>

                  )}



                </div>
              );
            })}

          </div>
          <div className={'panels-wrap'}>
            <InnerBlocks
              allowedBlocks={['post-grid/tabs-nested-item']}
              renderAppender={false}
              template={MY_TEMPLATE}
            />
          </div>
        </div>



      </>

    )
  },
  save: function (props) {
    // to make a truly dynamic block, we're handling front end by render_callback under index.php file

    var attributes = props.attributes;
    var tabs = attributes.tabs;

    var blockId = attributes.blockId;
    var activeTab = attributes.activeTab;
    var icon = attributes.icon;


    var blockIdX = attributes.blockId ? attributes.blockId : 'pg' + clientId.split('-').pop();
    var blockClass = '.' + blockIdX;

    const blockProps = useBlockProps.save({
      className: `${useBlockProps.save().className} ${blockId} pg-tabs`,
      id: blockId,

    });

    return (
      <InnerBlocks.Content />
    );


    //return null;

  }
})